import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId',
)({
    beforeLoad: ({ location, params }) => {
        throw redirect({
            to: '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId',
            params,
            search: location.search,
            replace: true,
        });
    },
    component: () => null,
});
